module.exports = __webpack_public_path__ + "static/media/logo.eb21a0c7.png";